<template>
  <el-row class="main-container">
    <el-col class="container-section-main">
      <goals-chart-preview
        :goals="currentGoals"
        :item="currentGoalItem"
        :met-goals="metGoals"
        item-type="seller"/>
      <goals-chart-preview :goals="currentGoals"/>
    </el-col>
  </el-row>
</template>
<script>
import GoalsChartPreview from '@/modules/goals/goals-chart-preview'
import GoalsGuards from '@/guards/goals.guards'
import multiguard from 'vue-router-multiguard'

export default {
  name: 'GoalsSellerDetail',
  components: {
    GoalsChartPreview
  },
  data () {
    return {
      listGoals: [],
      delearsClasification: {},
      currentItemList: null,
      listDealers: this.dealers
    }
  },
  computed: {
    itemsGoals () {
      return this.$store.getters['sellerGoals/items'] // TODO: change to respective resource
    },
    listItems () {
      return this.$store.getters['sellers/items'] // TODO: change to respective resource
    },
    metGoals () {
      return this.$store.getters['sellerGoals/metGoals'] // TODO: change to respective resource
    },
    currentGoalItem () {
      let _currentId = this.$route.params.id || this.listItems[0].id
      return this.listItems.find(item => {
        return parseInt(_currentId) === parseInt(item.id)
      })
    },
    currentGoals () {
      let _currentId = this.$route.params.id || this.listItems[0].id
      return this.itemsGoals.filter(goal => {
        return parseInt(_currentId) === parseInt(goal.userId) // TODO: change to respective id
      })
    }
  },
  beforeRouteUpdate: multiguard([
    GoalsGuards.onQueryGoalItems('sellers'),
    GoalsGuards.onQuerySellerGoals,
    GoalsGuards.onQueryMetGoals('sellerGoals', 'sellers/items')
  ]) // TODO: change to respective resource
}
</script>

<style lang="scss" scoped>
  .main-container{
    height: 100%;
    width: 100%;
    overflow: hidden;
    .container-section-main {
      height: calc(100% - 60px);
      position: relative;
      overflow: auto;
      margin-right: -50px;
      background-color: $secondary;
      padding: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/goals/goals-seller-detail.vue